import { useEffect, useState } from 'react'

import { VMMVModal, VMMVOverlay } from './style'

interface VMModalProps {
  children: (isLoaded: boolean) => React.ReactNode
}

export const VM_MODAL_ID = 'vmmv-modal-container'

export const VMModal: React.FC<VMModalProps> = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => setIsLoaded(true), [])

  return (
    <VMMVOverlay className="vmmv-modal-overlay">
      <VMMVModal
        role="dialog"
        id={VM_MODAL_ID}
        aria-modal="true"
        className="vmmv-modal-container"
        aria-label="Welcome to Virtual Mirror "
      >
        {children(isLoaded)}
      </VMMVModal>
    </VMMVOverlay>
  )
}
